import { render, staticRenderFns } from "./StoreGoods.vue?vue&type=template&id=5e5a2272&"
import script from "./StoreGoods.vue?vue&type=script&lang=js&"
export * from "./StoreGoods.vue?vue&type=script&lang=js&"
import style0 from "./StoreGoods.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports